module.exports = __webpack_public_path__ + "img/graphics.4ed2e1e7.jpg";